import { useEffect, React, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axios";

export default function NewlyArrivedBrands() {
  const [categories, setCategories] = useState([]);
  useEffect(()=>{
    const fetchData = async () => {
      try {
        const response = await axios.get("/categories");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching newly arrived brands:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const initSwiper = () => {
      if (window.Swiper) {
        new window.Swiper(".brand-carousel", {
          slidesPerView: 6,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: ".brand-carousel-next",
            prevEl: ".brand-carousel-prev",
          },
          breakpoints: {
            320: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            992: { slidesPerView: 6 },
            1200: { slidesPerView: 8 },
          },
        });
      } else {
        setTimeout(initSwiper, 100);
      }
    };

    initSwiper();
  }, []);


  return (
    <section className="py-2 overflow-hidden">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="section-header d-flex flex-wrap justify-content-between">
            
          
            </div>

            <div className="brand-carousel swiper">
              <div className="swiper-wrapper">
                {categories.map((cat, i) => (
                  cat.parent_id ? ( 
                  <div className="swiper-slide" key={i}>
                    <div className="row g-0">
                      <div className="col-12">
                        <Link to={`/categories/${cat.id}`} style={{ textDecoration: "none" }}>
                          <img
                            src={`${cat.image_url}`}
                            className="img-fluid"
                            alt="Brand Product"
                            style={{height: "170px", width: "100%" }}
                          />
                          <div className="brand-name text-center"><strong>{cat.name}</strong></div>
                        </Link>
                        </div>
                        <div className="col-md-12">
                          <div className="card-body py-0">
                           
                          </div>
                        </div>
                      </div>
                  </div>) : null
                  
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
